import React from 'react';
import PropTypes from 'prop-types';
import { BlockSize, UiPosition } from 'libs/rendering/gltf/config';

import { ResizePanelWrapper, PanelBorder } from './panel.styled';

const RESIZE_AREA = 8;
const MIN_WIDTH = BlockSize.constDesktopPanel;
const MAX_WIDTH = window.screen.availWidth / 2 - RESIZE_AREA;

export default class ResizePanel extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.setPosition('start');
  }

  setPosition = mode => {
    const { storedLeftPanelWidth, updateOutsideWidthSize } = this.props;

    if (this.ref !== null && this.ref?.current?.style) {
      this.ref.current.style.width = `${
        mode === 'start' ? storedLeftPanelWidth : MIN_WIDTH
      }px`;
      if (typeof this.ref.current.scroll !== 'undefined') {
        this.ref.current.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
    if (mode === 'reset' && updateOutsideWidthSize) {
      updateOutsideWidthSize(UiPosition.panel);
    }
  };

  range = number => {
    if (number < MIN_WIDTH) {
      this.handleMouseUp();
      return MIN_WIDTH;
    }
    if (number > MAX_WIDTH) {
      this.handleMouseUp();
      return MAX_WIDTH;
    }
    return number;
  };

  resize = event => {
    const move = this.position - event.x;
    this.position = event.x;

    const next =
      parseInt(
        this.ref === null
          ? MIN_WIDTH
          : this.ref.current.getBoundingClientRect().width,
        10,
      ) - (this.props.position === 'left' ? move : -move);

    if (this.ref !== null && this.ref?.current?.style) {
      const output = this.range(next);
      this.ref.current.style.width = `${output}px`;
      const { updateOutsideWidthSize } = this.props;
      if (updateOutsideWidthSize) updateOutsideWidthSize(output);
    }
  };

  handleMouseDown = event => {
    if (event.nativeEvent.offsetX < RESIZE_AREA) {
      event.preventDefault();
      event.stopPropagation();
      this.position = event.nativeEvent.x;
      document.addEventListener('mousemove', this.resize, false);
    }
  };

  handleMouseUp = () => {
    document.removeEventListener('mousemove', this.resize, false);
  };

  render() {
    const { isOpen, position } = this.props;

    return (
      <ResizePanelWrapper
        ref={this.ref}
        onMouseUp={this.handleMouseUp}
        isOpen={isOpen}
        position={position}
      >
        {this.props.children}
        {isOpen && (
          <PanelBorder
            position={position}
            resizeArea={RESIZE_AREA}
            onMouseDown={this.handleMouseDown}
            onDoubleClick={() => this.setPosition('reset')}
          />
        )}
      </ResizePanelWrapper>
    );
  }
}

ResizePanel.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  /**
   * Change the side position for the panel between 'left' and 'right'
   */
  position: PropTypes.oneOf(['left', 'right']),
  storedLeftPanelWidth: PropTypes.number,
  updateOutsideWidthSize: PropTypes.func,
};
